import * as React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from './auth-context'
import { ThemeProvider } from './theme-context'
import { WishlistProvider } from './wishlist-context'
import { TokenProvider } from './token-context'

function AppProviders({ children }: any) {
  return (
    <Router>
      <ThemeProvider>
        <TokenProvider>
          <AuthProvider>
            <WishlistProvider>{children}</WishlistProvider>
          </AuthProvider>
        </TokenProvider>
      </ThemeProvider>
    </Router>
  )
}

export { AppProviders }

